export default "https://legacy.eskolare-development.com/images/empty-order.png";